var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    stroke: "#2C3038",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5084 7.56051C18.7302 7.88621 18.9272 8.22811 19.0978 8.58333L21.5303 9.93365C21.8266 11.2944 21.8276 12.7029 21.5333 14.0641L19.0994 15.4151C18.9283 15.7701 18.7307 16.1117 18.5084 16.437L18.5552 19.2187C17.5249 20.1557 16.3056 20.8608 14.9797 21.2865L12.5927 19.8543C12.1997 19.8836 11.8051 19.8833 11.4122 19.8534L9.02655 21.2848C7.69996 20.861 6.47968 20.1576 5.44802 19.2222L5.49487 16.4389C5.27305 16.1132 5.07601 15.7713 4.90542 15.4161L2.47297 14.0658C2.17669 12.705 2.17567 11.2965 2.46998 9.93536L4.90379 8.58429C5.07494 8.22934 5.27252 7.88775 5.49486 7.56241L5.44803 4.78068C6.47834 3.84372 7.6976 3.1386 9.02358 2.71289L11.4105 4.1451C11.8035 4.11585 12.1981 4.11616 12.591 4.14604L14.9767 2.71462C16.3033 3.13841 17.5236 3.84176 18.5552 4.77723L18.5084 7.56051Z",
    stroke: "#2C3038",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGear);
export default __webpack_public_path__ + "static/media/ico-gear.e51d228d.svg";
export { ForwardRef as ReactComponent };